document.addEventListener('turbolinks:load', () => {

    const sgScreen = document.getElementById('sgScreen')
    const activateNumbPad = document.getElementById('activateNumbPad')
    const numbPad = document.getElementById('numbPad')
    const closeNumbPad = document.getElementById('closeNumbPad')
    const numbPadInput = document.getElementById('numbPadInput')
    const openNumberNumbPad = document.getElementById('openNumberNumbPad')
    const numbPadButtons = document.getElementsByClassName('numbPadButton')
    const numbPadNumberUp = document.getElementById('numbPadNumberUp')
    const numbPadNumberDown = document.getElementById('numbPadNumberDown')

    const dialNumberTableArea = document.getElementById('dialNumberTableArea')

    if (sgScreen !== null && numbPadInput !== null && openNumberNumbPad !== null &&
        numbPadNumberUp !== null && numbPadNumberDown !== null) {

        if(activateNumbPad !== null && numbPad !== null) {
            activateNumbPad.addEventListener('click', () => {
                numbPad.classList.remove('hidden')
                if (dialNumberTableArea !== null){
                    dialNumberTableArea.classList.remove('hidden')

                }
            })
        }
        //closeNumbPad isn't there on full screen
        if(closeNumbPad !== null && numbPad !== null){
            closeNumbPad.addEventListener('click', ()=>{
                numbPad.classList.add('hidden')
                if (dialNumberTableArea !== null){
                    dialNumberTableArea.classList.add('hidden')
                }
            })
        }

        openNumberNumbPad.addEventListener('click', openStation)

        for(let numbPadButton of numbPadButtons){
            numbPadButton.addEventListener('click', function(e){numbPadButtonClicked(e.target)})
        }
        numbPadNumberUp.addEventListener('click', numberUp)
        numbPadNumberDown.addEventListener('click', numberDown)

        resize(sgScreen)
    }

    function openStation(){
        let station_number = + numbPadInput.value
        let tour_id = openNumberNumbPad.dataset.current_tour
        if(isNaN(station_number)){
            window.alert(I18n.t('js.only_numbers'))
            return
        }
        let url = `/sg_preview/get_station_by_number/tour/${tour_id}/dial_number/${station_number}`

        $.rails.ajax({
            url: url,
            type: "get",
        })
    }

    function numbPadButtonClicked(button){
        // Sometimes the button element is set to the svg inside the button
        if (!button.classList.contains('numbPadButton')){
            button = button.closest('.numbPadButton')
        }
        if (button.dataset.value === "delete"){
            numbPadInput.value = numbPadInput.value.slice(0,-1)
        } else {
            // Replace undefined numbers and no heading 0s
            if (!parseInt(numbPadInput.value) && parseInt(numbPadInput.value) === 0){
                numbPadInput.value = button.dataset.value
            } else {
                numbPadInput.value += button.dataset.value
            }
        }
    }

    function numberUp(){
        let numPadVal = parseInt(numbPadInput.value)
        // if numPadVal is NaN, it evaluates to false
        if (numPadVal){
            numbPadInput.value = numPadVal + 1
        } else {
            numbPadInput.value = 1
        }
    }

    function numberDown(){
        let numPadVal = parseInt(numbPadInput.value)
        // if numPadVal is NaN, it evaluates to false and result number should not be below 0
        if (numPadVal && numPadVal > 0){
            numbPadInput.value = numPadVal - 1
        } else {
            numbPadInput.value = 0
        }
    }

    function resize(screen) {
        let resizeObserver = new ResizeObserver(() => {
            const currentSgScreenHeight = Math.max(screen.getBoundingClientRect().height, screen.getBoundingClientRect().width)
            numbPadInput.style.fontSize = `${currentSgScreenHeight / 48}px`
            numbPadInput.style.lineHeight = `${currentSgScreenHeight / 48}px`
        })
        resizeObserver.observe(screen);
    }
})